import { DesignRequestCreate } from "./DesignRequestCreate";
import { DesignRequestEdit } from "./DesignRequestEdit";
import { DesignRequestList } from "./DesignRequestList";
import { DesignRequestShow } from "./DesignRequestShow";

export const design_requests = {
    list: DesignRequestList,
    show: DesignRequestShow,
    create: DesignRequestCreate,
    edit: DesignRequestEdit,
    recordRepresentation: 'reference'
};
